<script>
import axios from 'axios';
import moment from 'moment';
import Swal from 'sweetalert2';
import Layout from '../../layouts/main';
import PageHeader from '@/components/page-header';
import RichTextEditor from '@/components/RichTextEditor.vue';
export default {
	page: {
		title: 'Volunteer System',
		meta: [
			{
				name: 'Volunteer System',
			},
		],
	},
	components: { Layout, PageHeader, RichTextEditor },
	data() {
		return {
			title: 'Email Templates',
			isLoading: false,
			isUpdating: false,
			emails: {},
			searchForm: {
				type: null,
				state: null,
				subject: null,
			},
			emailTypes: [
				{ id: 'mentor', name: 'Mentor' },
				{ id: 'volunteer', name: 'Volunteer' },
			],
			stateOptions: [
				{ id: 'in-state', name: 'In-State' },
				{ id: 'out-state', name: 'Out-State' },
			],
			editForm: {
				id: null,
				title: null,
				subject: null,
				body: null,
			},
			pageLimit: 20,
			modalTitle: '',
			isAdminUser: false,
			isInStateUser: false,
			isOutStateUser: false,
		};
	},
	filters: {
		moment: function (date) {
			if (date === null) {
				return '';
			}
			return moment(date, 'YYYY-MM-DD').format('MM/DD/YYYY');
		},
	},
	async mounted() {
		let component = this;
		await component.getEmailTemplates();
		component.calculateEditPermissions();
	},
	methods: {
		async getEmailTemplates(page = 1) {
			let component = this;
			component.isLoading = true;

			// pagination
			if (typeof page === 'undefined') {
				page = 1;
			}
			let filter = `pagination=true&page=${page}&per_page=${component.pageLimit}`;
			filter += component.searchForm.type ? `&type=${component.searchForm.type}` : '';
			filter += component.searchForm.state ? `&state=${component.searchForm.state}` : '';
			filter += component.searchForm.body ? `&body=${component.searchForm.body}` : '';

			try {
				let token = localStorage.getItem('token');
				if (!token) {
					await Swal.fire({
						title: 'Error!',
						text: 'Invalid login',
						icon: 'error',
						width: 350,
						showConfirmButton: true,
					});

					component.isLoading = false;
					return;
				}
				let config = {
					headers: {
						Authorization: 'Bearer ' + token,
						Accept: 'application/json',
					},
				};
				let result = await axios.get(`admin/email_templates?${filter}`, config);

				if (result.status !== 200) {
					await Swal.fire({
						title: 'Error!',
						text: 'Invalid login',
						icon: 'error',
						width: 350,
						showConfirmButton: true,
					});

					component.isLoading = false;
					return;
				}

				component.emails = result.data.response;
				component.isLoading = false;
				return;
			} catch (err) {
				if (err.response) {
					await Swal.fire({
						title: 'Error!',
						text: err.response.data?.error?.message || err.response.data?.message,
						icon: 'error',
						width: 350,
						showConfirmButton: true,
					});

					component.isLoading = false;
					return;
				}
			}
		},
		async resetForm() {
			let component = this;
			component.isLoading = true;
			component.searchForm.type = null;
			component.searchForm.state = null;
			component.searchForm.subject = null;
			await component.getEmailTemplates();
			component.isLoading = false;
		},
		editTemplate(template) {
			let component = this;
			component.editForm.id = template?.id;
			component.editForm.title = template?.title;
			component.editForm.subject = template?.subject;
			component.editForm.body = template?.body;

			// open modal
			component.modalTitle = 'Edit Email Template';
			component.$bvModal.show('templateModal');
		},
		updateTemplate() {
			let component = this;
			component.isUpdating = true;
			(async function () {
				try {
					let token = localStorage.getItem('token');
					if (!token) {
						await Swal.fire({
							title: 'Error!',
							text: 'Invalid login',
							icon: 'error',
							width: 350,
							showConfirmButton: true,
						});

						component.isUpdating = false;
						return;
					}
					let config = {
						headers: {
							Authorization: 'Bearer ' + token,
							Accept: 'application/json',
						},
					};
					let result = await axios.patch(`admin/email_templates/${component.editForm.id}`, component.editForm, config);
					if (result.status == 200) {
						await Swal.fire({
							title: 'Success!',
							text: 'Template Updated Successfully!',
							icon: 'success',
							width: 350,
							showConfirmButton: false,
							timer: 1500,
						});
						await component.getEmailTemplates();
					}
				} catch (err) {
					if (err.response) {
						await Swal.fire({
							title: 'Error!',
							text: err.response.data?.error?.message || err.response.data?.message,
							icon: 'error',
							width: 350,
							showConfirmButton: true,
						});
					}
				}
			})();
			component.modalTitle = '';
			component.$bvModal.hide('templateModal');
			component.isUpdating = false;
		},
		calculateEditPermissions() {
			let component = this;
			let user = JSON.parse(localStorage.getItem('user'));
			if (!user) {
				return;
			}

			if (user.user_type_id == 1) {
				component.isAdminUser = true;
			}

			if (user.locations) {
				let minneapolisLocationId = 2;
				let userLocations = Array.from(user.locations);
				component.isInStateUser = userLocations.includes(minneapolisLocationId);
				component.isOutStateUser = !userLocations.includes(minneapolisLocationId);
			}
		},
		hasEditPermission(template) {
			let component = this;
			let inStateTemplate = template?.tag?.toLowerCase().startsWith('in_');
			if (component.isAdminUser) {
				return true;
			}

			if (inStateTemplate && component.isInStateUser) {
				return true;
			}

			if (!inStateTemplate && component.isOutStateUser) {
				return true;
			}

			return false;
		},
	},
};
</script>

<template>
	<Layout>
		<PageHeader :title="title" />
		<div class="card">
			<div class="card-body">
				<!-- search filter -->
				<div class="row">
					<div class="col-12">
						<form class="align-items-center form-inline mb-4 border p-3 m-0" @submit.prevent="() => getEmailTemplates()">
							<div class="row">
								<div class="col-md-4">
									<label>Subject</label>
									<input v-model="searchForm.subject" type="text" class="ps-4 form-control" placeholder="Type Email Subject" />
								</div>
								<div class="col-md-4">
									<label>In-State/Out-State</label>
									<b-form-select class="form-select" v-model="searchForm.state" :options="stateOptions" value-field="id" text-field="name">
										<option slot="first" :value="null">-- All --</option>
									</b-form-select>
								</div>
								<div class="col-md-4">
									<label>Type</label>
									<b-form-select class="form-select" v-model="searchForm.type" :options="emailTypes" value-field="id" text-field="name">
										<option slot="first" :value="null">-- All Types --</option>
									</b-form-select>
								</div>
							</div>
							<div class="row justify-content-end">
								<div class="col-md-2 d-grid">
									<label>&nbsp;</label>
									<button type="button" @click="resetForm" class="btn btn-light btn-reset" id="show-btn"><i class="bx bx-reset"></i> Reset</button>
								</div>
								<div class="col-md-2 d-grid">
									<label>&nbsp;</label>
									<button type="submit" class="btn btn-block btn-primary"><i class="bx bx-search-alt-2"></i> Filter</button>
								</div>
							</div>
						</form>
					</div>
				</div>
				<!-- search filter end -->

				<!-- content table -->
				<div class="row">
					<div class="col-12">
						<div class="table-responsive">
							<table class="table table-bordered table-hover table-striped align-middle mb-0">
								<thead class="table-light">
									<tr>
										<th scope="col">ID</th>
										<th scope="col">State</th>
										<th scope="col">Type</th>
										<th scope="col">Subject</th>
										<th scope="col">Title</th>
										<th scope="col">Last Updated</th>
										<th scope="col">Actions</th>
									</tr>
								</thead>
								<tbody>
									<!-- data loading -->
									<tr v-if="isLoading">
										<td colspan="8" class="text-center p-0">
											<b-spinner class="m-2" variant="primary" role="status"></b-spinner>
										</td>
									</tr>

									<!-- no records -->
									<tr v-if="!isLoading && emails.data && emails.data.length == 0">
										<td colspan="8" class="p-0">
											<p class="font-size-16 text-center mt-2 mb-0">Record Not Found!</p>
										</td>
									</tr>

									<!-- data -->
									<tr v-else v-for="(template, index) in emails.data" :key="index">
										<td>
											<p class="text-muted mb-0 text-wrap">{{ template.id }}</p>
										</td>
										<td>
											<p class="text-muted mb-0 text-wrap">{{ template.tag.startsWith('in_') ? 'In-State' : 'Out-State' }}</p>
										</td>
										<td>
											<p class="text-muted mb-0 text-wrap">{{ template.type.toUpperCase() }}</p>
										</td>
										<td>
											<p class="text-muted mb-0 text-wrap">{{ template.subject }}</p>
										</td>
										<td>
											<p class="text-muted mb-0 text-wrap">{{ template.title }}</p>
										</td>
										<td>
											<p class="text-muted mb-0 text-wrap">{{ template.updated_at | moment }}</p>
										</td>
										<td>
											<button type="button" class="btn btn-primary" :disabled="!hasEditPermission(template)" @click="() => editTemplate(template)">Edit</button>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<pagination class="mt-4" :data="emails" :limit="pageLimit" @pagination-change-page="getEmailTemplates"></pagination>
					</div>
				</div>
				<!-- content table end -->

				<!-- edit template modal -->
				<b-modal id="templateModal" size="lg" centered :title="modalTitle" title-class="font-18" hide-footer>
					<div class="row">
						<div class="col-12 mb-3">
							<label>Title</label>
							<input v-model="editForm.title" class="form-control" name="title" placeholder="Title" :disabled="isUpdating" />
						</div>
						<div class="col-12 mb-3">
							<label>Subject</label>
							<input v-model="editForm.subject" class="form-control" name="subject" placeholder="Subject" :disabled="isUpdating" />
						</div>
						<div class="col-12 mb-3">
							<label>Body</label>
							<RichTextEditor cssClasses="form-control" v-model="editForm.body" />
						</div>
					</div>
					<div class="row">
						<div class="col-12 mb-0">
							<div>
								<button type="button" @click="updateTemplate" class="btn btn-primary" :disabled="isUpdating">Update</button>
							</div>
						</div>
					</div>
				</b-modal>
				<!-- edit template modal end-->
			</div>
		</div>
	</Layout>
</template>

<style scoped></style>
